/**
 * Module vevidental — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { ROLES_RECHERCHE_VEVIDENTAL } from "@geceram/shared";
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "vevidental",
  label: "Vevidental",
  icon: "i-db",
  navGroup: "finance",
  navOrder: 20,
  // Mêmes rôles que la recherche du serveur (25/10) : un écran dont la
  // recherche serait refusée ne doit pas s'ouvrir.
  rolesRequis: ROLES_RECHERCHE_VEVIDENTAL,
  routes: [{ path: "/vevidental", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
